/**
 * @module FieldControls
 */
import { createStyles, FormControl, FormHelperText, IconButton, Input, InputAdornment, InputLabel, makeStyles, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { renderIconDefault } from "./icon.js";
import { defaultLocalization } from "./localization.js";
const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      '& input::-ms-reveal': {
        display: 'none'
      }
    }
  });
});
/**
 * Field control that represents a Password field. Available values will be populated from the FieldSettings.
 */

export const Password = props => {
  var _props$localization;

  const localization = deepMerge(defaultLocalization.password, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.password);
  const [value, setValue] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const classes = useStyles();

  const handleChange = e => {
    var _props$fieldOnChange;

    setValue(e.target.value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, e.target.value);
  };

  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: props.settings.Name,
        shrink: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Input, {
        autoComplete: "new-password",
        type: showPassword ? 'text' : 'password',
        name: props.settings.Name,
        id: props.settings.Name,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        onChange: handleChange,
        value: value,
        fullWidth: true,
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          "aria-label": localization.toggleVisibility,
          onClick: () => setShowPassword(!showPassword)
        }, props.renderIcon ? props.renderIcon(showPassword ? 'visibility_off' : 'visibility') : renderIconDefault(showPassword ? 'visibility_off' : 'visibility')))
      }), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));

    default:
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName);
  }
};
//# sourceMappingURL=password.js.map